import { Box } from '@mui/system';
import React, { ReactNode } from 'react';

export const WidgetSpacer = ({ children }: { children?: ReactNode }) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '300px',
      width: '100%',
    }}
  >
    {children}
  </Box>
);
